import React, { Fragment, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import CetagorySidebar from '../../../components/CetagorySidebar'
import FooterArea from '../../../components/FooterArea'
import BannerSidebar from '../../../components/BannerSidebar'
import SingleContentArea from '../../../components/SingleContentArea'
import banner from '../../../images/practice/2.jpg'
import single from '../../../images/practice/3.jpg'

import './style.scss'

const PracticeSinglePage = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get('category');

    const [selectedCategory, setSelectedCategory] = useState(categoryParam || 'Estate Planning');

    // Update state if URL param changes (e.g., user clicks back button)
    useEffect(() => {
        if (categoryParam) {
            setSelectedCategory(categoryParam);
        }
    }, [categoryParam]);

    return (
        <Fragment>
            <div className="singleArea">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <aside className="pr25">
                                <CetagorySidebar
                                    title="Category"
                                    className="cetagoryWrap"
                                    onSelectCategory={setSelectedCategory}
                                    selectedCategory={selectedCategory}
                                />
                            </aside>
                        </div>
                        <div className="col-lg-8">
                            <SingleContentArea
                                className="singleContentArea"
                                image={single}
                                avatar={true}
                                selectedCategory={selectedCategory}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default PracticeSinglePage;
